"use strict";
/*
Copyright 2018 - 2022 The Alephium Authors
This file is part of the alephium project.

The library is free software: you can redistribute it and/or modify
it under the terms of the GNU Lesser General Public License as published by
the Free Software Foundation, either version 3 of the License, or
(at your option) any later version.

The library is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Lesser General Public License for more details.

You should have received a copy of the GNU Lesser General Public License
along with the library. If not, see <http://www.gnu.org/licenses/>.
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.safePublicKeyLikeCodec = exports.publicKeyLikeCodec = void 0;
const checksum_codec_1 = require("./checksum-codec");
const codec_1 = require("./codec");
const byte33Codec = new codec_1.FixedSizeCodec(33);
exports.publicKeyLikeCodec = new codec_1.EnumCodec('public key like', {
    SecP256K1: byte33Codec,
    SecP256R1: byte33Codec,
    ED25519: codec_1.byte32Codec,
    WebAuthn: byte33Codec
});
exports.safePublicKeyLikeCodec = new checksum_codec_1.Checksum(exports.publicKeyLikeCodec);
